import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  image = 'https://res.cloudinary.com/dnx6y0737/image/upload/f_auto,q_auto/v1775900226/Untitled_design_1_cziq8t.png',
  url 
}) => {
  const siteName = 'Sfension';
  const fullTitle = title ? `${siteName} - ${title}` : `${siteName} - Restoran Zvečan`;
  const defaultDescription = 'Restoran Sfension u Zvečanu - tradicionalna kuhinja, prijatna atmosfera i nezaboravni trenuci. Rezervišite sto već danas.';
  const finalDescription = description || defaultDescription;
  const siteUrl = 'https://sfension.rs';
  const finalUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Osnovni meta */}
      <title>{fullTitle}</title>
      <meta name="description" content={finalDescription} />
      <link rel="canonical" href={finalUrl} />

      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="sr_RS" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={image} />

      {/* Geo tags */}
      <meta name="geo.region" content="RS" />
      <meta name="geo.placename" content="Zvečan" />
      {/* Restaurant Schema */}
<script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Restaurant",
    "name": "Sfension",
    "image": image,
    "url": siteUrl,
    "telephone": "+381669811881",
    "email": "sfensionzvecan@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Kralja Petra I",
      "addressLocality": "Zvečan",
      "addressCountry": "RS"
    },
    "openingHours": "Mo-Su 08:00-23:00",
    "servesCuisine": "Serbian",
    "priceRange": "€€"
  })}
</script>
    </Helmet>
  );
};

export default SEO;